var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDynamicPricingStationDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 8,
    fill: "#1A2128"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 27V10C8.5 8 9.84 7 11.5 7H19.5C21.16 7 22.5 8 22.5 10V27H8.5Z",
    stroke: "#E9ECEF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 27H24",
    stroke: "#E9ECEF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.39 15H17.62C18.66 15 19.51 14.5 19.51 13.11V11.88C19.51 10.49 18.66 9.98999 17.62 9.98999H13.39C12.35 9.98999 11.5 10.49 11.5 11.88V13.11C11.5 14.5 12.35 15 13.39 15Z",
    stroke: "#E9ECEF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 18H14.5",
    stroke: "#E9ECEF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 21.01L27 21V15L25 14",
    stroke: "#E9ECEF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDynamicPricingStationDark);
export default __webpack_public_path__ + "static/media/dynamic-pricing-station-dark.ce18b53a446393bed81c5f363fbdde20.svg";
export { ForwardRef as ReactComponent };